module.exports = __webpack_public_path__ + "static/media/Anonimo_Edited_Caroussel.4511d3eb.jpg";